import React, { useState, useEffect } from "react";
import { images } from "../shared/images";
import { Link } from "react-router-dom";
import { NavHashLink } from "react-router-hash-link";
import { useLocation } from "react-router-dom";
import { NavLink } from "react-router-dom";

const Header = () => {
	const [openHeader, setOpenHeader] = useState(false);
	const location = useLocation();

	useEffect(() => {
		setOpenHeader(false);
		window.scrollTo(0, 0);
	}, [location.pathname]);

	return (
		<>
			<div className="header">
				<a href="https://nitro.network/" className="logo">
					<img src={images.logo} alt="Logo" />
				</a>
				<div className="links">
					<Link to="/">Home</Link>
					{/*<Link to="/whitelist">Whitelist</Link>*/}
					<NavHashLink to="/#story">Story</NavHashLink>
					<NavLink to="/faq">FAQ's</NavLink>
					<NavLink to="/staking">Staking</NavLink>
					<NavLink to="/rewards">Rewards</NavLink>
				</div>
				<div className="enter-ecosystem">
					<a
						href="https://nitro.network/"
						rel="noopener"
						target="_blank"
						className="enter-eco-button"
					>
						Enter Ecosystem{" "}
					</a>
				</div>
				<div
					className="mobile-icons"
					onClick={() => setOpenHeader(!openHeader)}
				>
					{openHeader ? (
						<i className="fa-solid fa-xmark"></i>
					) : (
						<i className="fa-solid fa-bars"></i>
					)}
				</div>

				{/* Mobile view navigation */}

				<div
					onClick={() => setOpenHeader(false)}
					className={`mobile-view-box ${openHeader ? "open" : ""}`}
				>
					<Link to="/">Home</Link>
					{/*<Link to="/whitelist">Whitelist</Link>*/}
					<NavHashLink to="/#story">Story</NavHashLink>
					<NavLink to="/faq">FAQ's</NavLink>
					<NavLink to="/staking">Staking</NavLink>
					<NavLink to="/rewards">Rewards</NavLink>
					<a
						href="https://nitro.network/"
						rel="noopener"
						target="_blank"
						className="enter-eco-button"
					>
						Enter Ecosystem{" "}
					</a>
				</div>
			</div>
		</>
	);
};

export default Header;
